import React, { useEffect, useState } from 'react';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import WidgetWrapper from '../widget-wrapper/widget-wrapper';
import ChartSkeleton from '../../ui/chart-skeleton/chart-skeleton';
import SingleLineCharts from '../../ui/SinglelineCharts/singlelineCharts';
import SingleTabTable from '../../ui/SingleTabTable';
import styles from '../maiWidgets/mai-widget.module.css';

export default function DRWidget() {
  const { state } = useSamarthDashboardContext();
  const globalViewMode = state.viewMode.globalViewMode;
  const chartData = state.dashboardData.drData;
  const loader = state.dashboardData.isLoading.drData;
  const { filters } = state;
  const [isOn, setIsOn] = useState(false);
  const [currentTDPData, setCurrentTDPData] = useState([]);

  useEffect(() => {
    if (!Array.isArray(chartData)) {
      setCurrentTDPData([]);
      return;
    }

    const match = chartData.find((data) => data.label === filters.tdp);
    const resolvedData = filters.actionFilter?.length ? Array.isArray(match?.data) ?  match.data : [] : chartData;

    const slicedData = isOn
      ? resolvedData
      : filters.actionFilter?.length
      ? resolvedData.slice(0, 4)
      : resolvedData.slice(-4);

    setCurrentTDPData(slicedData);
  }, [filters.tdp, chartData, isOn, filters.actionFilter]);

  return (
    <WidgetWrapper
      title="DR"
      isTableView={globalViewMode === 'table'}
      isDialogOpen={isOn}
      setIsDialogOpen={() => setIsOn(!isOn)}
      infoText="DR measures the number of cases dispatched to the final expected order quantity. (GT, KA, RD)"
    >
      {loader ? (
        <div style={{ width: '100%', height: '100%' }}>
          <ChartSkeleton isOn={false} />
        </div>
      ) : (
        <div style={{ height: '100%' }}>
          {globalViewMode === 'graph' ? (
            <SingleLineCharts
              data={currentTDPData}
              dataKey="label"
              valueKey="value"
              isExpansionNeeded={!!filters.actionFilter}
            />
          ) : (
            <SingleTabTable
              data={currentTDPData}
              keys={['label', 'value']}
              colorLogic={(value) => {
                if (value < 30) return styles.textRed;
                if (value < 50) return styles.textYellow;
                return styles.textGreen;
              }}
            />
          )}
        </div>
      )}
    </WidgetWrapper>
  );
}
